<template>
  <div>
    <NoTopNavFooter/>
    <div id="login-background" style="">
      <spinner :spinnerOn="loading"></spinner>
      <!-- v-bind:class="{ opaqueSpinner: isFromUserReg } -->
      <img src="" class="splash hiddden" alt="">
		  <div v-bind:class="{'pull-up': samlappname !== undefined && samlappname !== null && (samlappname.toLowerCase().indexOf('secure.cargillag.com') > -1 || samlappname.toLowerCase().indexOf('secure.cargillag.ca') > -1)}">
	      <div v-if="stateToken.trim() != '' && stateToken.trim() !== undefined  && stateToken.trim() !== null && brandCode !== '003'"
	        style="text-align: center;padding-bottom: 5px;font-weight: bold;">{{ connectingToText ? connectingToText : 'Connecting to' }}
          <img id="saml-logo" style="max-width: 100px;">
        </div>
	    </div>
      <div class="loginBrandTopText" v-if="loginBrandTopText.trim() !== ''">{{loginBrandTopText}}</div>
      <div id="widget-div"></div>
      <div v-show = "accessDenied" class="clogindiv" style="text-align: center;color: rgb(217, 57, 52);padding: 5px;font-size: 14px;padding: 10px 30px;">
        <div style="border: 1px solid #ddd;border-radius: 3px;height: 45px;">
          <div style="display: inline-block;float: left;height: 100%;background: rgb(217,57,52);
            color: #fff;padding: 7px 3px 10px 7px;border-top-left-radius: 3px;border-bottom-left-radius: 3px;">
            <i class="fa fa-exclamation-circle" style="margin-right: 5px; font-size: 16px;"></i>
          </div>
          <div style="display: inline-block;color: #000000;float: left;padding: 7px 3px 10px 10px;">Access denied</div>
        </div>
      </div>
      <!--div v-show = "accessDenied" class="clogindiv" style="text-align: center;color: #d93934;padding: 5px;margin-bottom: 8px;font-size:14px;">
      <i class="fa fa-exclamation-circle" style="margin-right:5px;font-size:16px;"></i>Access denied</div-->
      <div class="clogindiv" v-if="isEmployeeLoginRequired"><button class="btn btn-primary adduser-btn" style="" id="cargillLogin" v-on:click="openCargillUserLogin()">
        {{ ssoLoginTxt ? ssoLoginTxt : 'Sign In as an Employee' }}</button></div>
      <!--div class="loginBrandBottomText" v-if="loginBrandBottomText !== undefined && loginBrandBottomText !== null && loginBrandBottomText.trim() !== ''">
        <span v-html="loginBrandBottomText"></span> </div-->
    </div>
  </div>
</template>
<script>
  import NoTopNavFooter from "@/components/widgets/NoTopNavFooter"
  import okta from '@/helpers/okta'
  import storage from '../helpers/storage';
  import idmApi from '@/idm-api'
  import base64 from 'base-64'
  // import authapi from '@/helpers/auth-api'
  import Spinner from '@/components/Spinner'
  import { locale } from '@/i18n/locale.js'
  import { EventBus } from '@/event-bus.js';
  import translationConfig from '../helpers/translationConfig';
  import oktaConfigs from '../helpers/okta-config';
  const orgUrl = window.location.href.indexOf("identityservices.mycargill.com") > -1 ? process.env.CUSTOM_ORG_URL : process.env.ORG_URL;
  const ssoUrl = window.location.href.indexOf("identityservices.mycargill.com") > -1 ? process.env.CUSTOM_SSO_URL : process.env.SSO_URL;
  let brandDetails = "";
  let environment = process.env.NODE_ENV;
  if (environment === 'production') {
    brandDetails = require('../brand-details.json');
  } else if (environment === 'stage') {
    brandDetails = require('../brand-details-stage.json');
  } else {
    brandDetails = require('../brand-details-dev.json');
  }
  var brand = brandDetails.data.filter(i => i.applicationUrls.indexOf(document.location.host) > -1)
  var browserEnv = ''
  if (document.location.host.indexOf('dev-cglcloud.com') > -1 || document.location.host.indexOf('localhost') > -1) {
    browserEnv = 'Dev'
  } else if (document.location.host.indexOf('stage.cglcloud.in') > -1) {
    browserEnv = 'Stage'
  } else {
    browserEnv = 'Prod'
  }
  export default {
    name: 'login',
    components: {
      NoTopNavFooter,
      Spinner
    },
    data() {
      return {
        samlappname: '',
        brandDetails: brandDetails,
        stateToken: '',
        isMobile: "ontouchstart" in document.documentElement, // /Mobi/.test(window.navigator.userAgent)
        loading: true,
        loginErrors: [],
        resetOptionErrors: [],
        verifyCodeErrors: [],
        resetPasswordErrors: [],
        isFromUserReg: true,
        lang: locale.lang,
        lang_obj: locale.lang_obj,
        user_lang: {},
        toggleHelp: false,
        forgotPassword: false,
        resetviaSMS: false,
        resetviaEmail: false,
        mailForReset: '',
        userIdForReset: '',
        countdown_number: 30,
        username: '',
        password: '',
        smsStatus: '',
        resetpassword: '',
        repeatpassword: '',
        passwordPolicyArray: [],
        currPwdPolicy: {},
        pwdComplexity: {},
        pwdErrorArray: [],
        secQuestionErrorArray: [],
        smsFactorId: '',
        stateTokenToResetBySMS: '',
        OTP: '',
        codeVerified: false,
        secQuestionVerified: false,
        recoveryQuestion: '',
        securityAnswer: '',
        minSecurityAnswerLength: '',
        accessDenied: false,
        ssoLangs: translationConfig,
        connectingToLangs: { 'id': 'Terhubung ke',
          'pt-br': 'Conectando à',
          'pl': '�?ączenie z',
          'es': 'Conectado a',
          'en': 'Connecting to' },
        ssoLoginTxt: 'Sign In as an Employee',
        connectingToText: 'Connecting to',
        samlRD: '',
        loginBrandTopText: '',
        loginBrandBottomText: '',
        linkToOldEc: '',
        brandCode: '',
        isEmployeeLoginRequired: true
      }
    },
    props: {
    },
    computed: {
    },
    created() {
      var self = this
      /* let tokenParams = document.location.href.split('=')
      if (tokenParams[1] === 'true') {
        self.setUserLocale(storage.get('email'))
      } */
      setTimeout(self.assignUserLang(), 1000) // lang_br for br portuguese lang
      EventBus.$on('lang', function (language) {
        self.user_lang = self.lang_obj[language]
      })
      $(document).on('click', '#okta-signin-submit, #cargillLogin', function() {
        self.accessDenied = false
      })
      $(document).on('click', '.linkToOldEc', function(e) {
        window.open(e.innerText, '_blank')
      })
    },
    mounted() {
      this.getBrandName()
      okta.oktaSignIn();
      var bUrl = document.location.href;
      this.onMountLogin(bUrl)
      okta.oktaWidgetRendered(this.proceedUnlock)
    },
    methods: {
      proceedUnlock() {
        if (window.location.href.indexOf('action=unlock') > -1) {
          document.querySelector('.js-unlock').click();
        }
      },
      onMountLogin(bUrl) {
        var fromLogin = this.getParameterByName('fromLogin', bUrl)
        console.log('return url:' + this.getParameterByName('ReturnUrl', bUrl))
        var rd = this.getParameterByName('rd', bUrl)
        var isRdEncode = this.getParameterByName('encode', bUrl)
        if (rd === undefined || rd === null || rd.trim() === '') {
          rd = this.getParameterByName('ReturnUrl', bUrl)
        }
        if (rd !== undefined && rd !== null && rd.trim() !== '') {
          if (isRdEncode === 'true') {
            rd = base64.decode(rd)
          }
          this.samlRD = ssoUrl.split('=')[0] + '=' + rd
        }
        var browserLang = 'en'
        var custLang = this.getParameterByName('lang', bUrl)
        console.log("urllang" + custLang);
        if (navigator.userLanguage !== undefined) {
          browserLang = navigator.browserLanguage
          console.log("browserLang: if " + browserLang)
        } else {
          browserLang = navigator.language
          console.log("browserLang: else " + browserLang)
        }
        browserLang = custLang != null ? custLang : browserLang;
        console.log("urllang after custLang" + browserLang);
        if (browserLang.startsWith('zh')) {
          if (browserLang.indexOf('zh_CN')) {
            browserLang = 'cn';
          } else {
            browserLang = 'bg';
          }
        } else {
          browserLang = browserLang.replace("_", "-")
          console.log("browserLang: after replace " + browserLang)
          browserLang = oktaConfigs.getBrowserLanguage(browserLang)
          console.log("browser language: final " + browserLang)
        }
        this.ssoLoginTxt = this.ssoLangs[browserLang];
        this.connectingToText = this.connectingToLangs[custLang ? custLang.toLowerCase() : 'en']
        if (fromLogin !== true && fromLogin !== 'true') {
          storage.set('samlapp', '')
        }
        var stateToken = this.getParameterByName('stateToken', bUrl)
        var fromURI = this.getParameterByName('fromURI', bUrl)
        var self = this
        self.loading = false
        var regex = new RegExp("access_denied")
        if (regex.test(bUrl)) {
          self.accessDenied = true
        }
        if (stateToken !== undefined && stateToken !== null && stateToken !== '') {
          this.stateToken = stateToken
          let data = {
            "stateToken": stateToken
          }
          idmApi.getCurrentState(data)
          .then((response) => {
            console.log(response.data._embedded.target.name)
            $('#saml-logo').attr('src', response.data._embedded.target._links.logo.href)
            self.samlappname = response.data._embedded.target.label
            // storage.set('samlapp', response.data._embedded.authentication.issuer.id)
            document.title = response.data._embedded.target.label
            storage.set('samlapp', '')
          })
        } else if (fromURI !== undefined && fromURI !== null && fromURI !== '') {
          var deconstruct = fromURI.split('/')
          var appname = deconstruct.indexOf('app') > -1 ? deconstruct[deconstruct.indexOf('app') + 1] : ''
          // storage.set('samlapp', appname)
          console.log(appname)
          storage.set('samlapp', '')
        }
      },
      assignUserLang() {
        var self = this
        self.user_lang = self.lang_obj[this.lang]
      },
      openCargillUserLogin() {
        var url = orgUrl + (this.samlRD.trim() !== '' ? this.samlRD : ssoUrl)
        var samlProviderId = ssoUrl.split('/')[2].substr(0, ssoUrl.split('/')[2].indexOf('?'))
        if (window.location.href.toLowerCase().indexOf('cargill') === -1) {
          url = orgUrl + 'sso/saml2/' + samlProviderId + '?fromURI=' + window.location.href
        }
        window.open(url, '_self')
      },
      getParameterByName: function (name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
        var results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
      },
      getBrandName: function () {
        var self = this
        var bgimg = brand.length ? brand[0].bgImageLink.trim() : ''
        this.brandCode = brand.length ? brand[0].brandCode : ''
        this.isEmployeeLoginRequired = brand.length ? brand[0].isEmployeeLoginRequired : true
        this.loginBrandTopText = brand.length ? brand[0].LoginWidgetTopContent : ''
        var loginBrandBottomText = brand.length ? brand[0].LoginWidgetBottomContent : ''
        var linkToOldEc = brand.length ? brand[0]['linkToOldEC-' + browserEnv] : ''
        this.linkToOldEc = '<span class="linkToOldEc">' + linkToOldEc + '</span>'
        this.loginBrandBottomText = loginBrandBottomText.replace("<INSERT LINK TO OLD EC ENVIRONMENT>", this.linkToOldEc)
        if ($('.splash').length !== 0) {
          if (bgimg !== '') {
            if (bgimg.indexOf('#') !== 0) {
              console.log('before' + $('.splash').attr("src"))
              $('.splash').attr("src", bgimg)
              console.log('after' + $('.splash').attr("src"))
            } else {
              $('.splash').attr("src", "")
              $('.splash').css("background", bgimg)
            }
          }
          if (self.brandCode === '007') {
            setTimeout($('.splash').addClass('opacBg'), 500);
          }
          setTimeout($('.splash').removeClass('hiddden'), 500);
        }
        console.log(self.brandCode)
        setTimeout(function () {
          if ($('.auth-org-logo').length !== 0 && brand.length && brand[0].brandName.toLowerCase() === 'agresource') {
            // $('.auth-org-logo')[0].style.webkitFilter = "invert(50%)"
          }
          if (self.brandCode === '007') {
            // $('.okta-sign-in-header.auth-header').hide()
            document.getElementsByClassName('auth-header')[0].style.paddingBottom = '0px'
          }
        }, 1000);
      }
    }
  }
</script>
<style scope>
html, body {
  background-color: #FFF;
  margin: 0px;
  height: auto;
}
#login-background {
  background-color: #FFF;
  padding: 0;
  margin:0;
  /*background: url(https://www.cargill.com/image/1432079677619/hero-ag-market-landing.jpg) no-repeat !important;*/
}
.login-form, .forgotPasswordSection{max-width: 400px;    margin: auto;}
.form-control{margin: 10px 0px;}
.non-anchor-link{cursor:pointer;user-select:none;display: inline-block;margin-top: 3px;}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.15s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.logo{margin:20px;text-align: center;}
.logo img {max-width: 120px;
	    width: 120px;}
.instruction {font-size:13px;}
button {text-transform: none !important;}
button:focus {color: #ffffff !important;}
body{background: #FFF; /* url(https://www.cargill.com/image/1432079677619/hero-ag-market-landing.jpg) no-repeat */
    background-size: cover;}
#app, #login-background, html{background:transparent}
.custom-login{padding:20px;max-width: 440px;
    margin: auto;
    background: #ffffff97;border-radius: 2px;}
.mailsent, .entersmssent{text-align: center;
    font-weight: bold;}
.emailsenttext{font-size: 14px;
    margin-bottom: 30px;text-align: center;}
.btn{cursor:pointer}
.resend-code{cursor: pointer}
.resend-code:focus{color:#464a4c !important}
.disabled {pointer-events:none;opacity:0.5}
.alternateReset {font-size: 14px;text-decoration:none;text-align: center; cursor:pointer;margin-bottom:15px;}
#login-background{
    width: calc(100vw);
    box-sizing: border-box;
    height: calc(100vh);
    background-size: cover !important;
    /* margin-top: -64px; */
    padding-top: 60px;
}
.alternateReset:hover {text-decoration:underline;}
.errorList{color:#d00000; background: #ffc6d195;
    padding: 5px;}
.opaqueSpinner {background: white !important;}
.pwderror{display: block;
    background: #c5c5c5;
    padding-left: 10px;
    color: #ffffff;
    border-bottom: 1px solid #eaeaea;
    max-width: 400px;}
.splash{
position: absolute;
    top: 0px;
    width: 100%;
    height: 100%;
    z-index: -1;
	object-fit: cover;}
.clogindiv{
 width: 300px;
    background-color: #fff !important;
    margin: auto;
    padding: 20px 30px;
    z-index: 999999999;
    margin-top: -7px;
    border-radius: 3px;
}
#cargillLogin{
    white-space: normal;
    background-color: var(--theme-primary);
    font-weight: normal;
    width: 100%;
    border-radius: 1px;
    font-size: 13px;
    box-shadow: rgba(0, 0, 0, 0.15) 0 1px 0, rgba(255, 255, 255, 0.1) 0 1px 0 0 inset;
	cursor:pointer;
}
.hiddden{visibility:hidden;}
.loginBrandBottomText{
    max-width: 800px;
    text-align: center;
    padding: 10px;
    margin: 0px auto;
    font-size: 12px;
    background: #f7f7a5;
	margin-top:10px;	
    font-weight: bold;}
.loginBrandTopText{
    max-width: 600px;
    text-align: left;
    margin: 0px auto;
    padding: 15px;
	max-height: 160px;
    overflow: auto;
    margin-bottom: 10px;
	border: 1px solid #ccc;
	background:#fff;
	border-radius: 10px;
	font-size: 14px;
	}
.linkToOldEc{
   cursor:pointer;
   color:blue;
   font-decoration:underline;
}
.disabled {
    cursor: none;
    pointer-events: none;
    opacity:0.7;
}
.opacBg{
  opacity:0.8;
}
@media screen and (max-width: 770px) {
}
#okta-sign-in{
margin-top: 0px !important;
}
.notification-pane{    
    background: rgba(252, 248, 227, 0.95);
    padding: 8px 20px;
    border: 1px solid #fdd78a;
    color: #ef2626;
    max-width: 600px;
    margin: 0px auto;
    line-height: 20px;
    font-size: 14px;
    margin-bottom: 5px;
    font-weight: bold;
    font-style: italic;
    border-radius: 10px;
}
.pull-up{margin-top:-30px;}
::-webkit-scrollbar {
    -webkit-appearance: none;
}
::-webkit-scrollbar:vertical {
    width: 12px;
}
::-webkit-scrollbar:horizontal {
    height: 12px;
}
::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, .5);
    border-radius: 10px;
    border: 2px solid #ffffff;
}
::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #ffffff;
}
@media only screen and (max-width:360px) {
  .clogindiv {
    margin-right: 22px;
  }
}
.okta-form-label {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// Login.vue?32397943